// src/components/TrophyRoom/TabPanel.js
import React from 'react';
import { Box } from '@mui/material';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`trophy-tabpanel-${index}`}
      aria-labelledby={`trophy-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default TabPanel;